import { render, staticRenderFns } from "./teacherManage.vue?vue&type=template&id=3326c6d9"
import script from "./teacherManage.vue?vue&type=script&lang=js"
export * from "./teacherManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports